import { api } from "./api";

const CHUNK = 4 * 1024 * 1024;

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export async function uploadFile(file, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = `${Date.now()}${Math.random().toString(36).slice(2, 10)}`;
  let res;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", i);
    fd.append("total", total);
    fd.append("filename", file.name);
    fd.append("content_type", file.type);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    res = await api.post("/admin/files/chunk", fd);
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return res.data;
}
